import React from "react";

const Breadsrumb1 =({data})=>{
if(data.length > 0){
    return(
        <div className="col-12 p-0 mb-2 bread-crumb mt-2" style={{zIndex:999999}}>
            <ul className="d-flex pe-0">
                <li>
                    <a href="/"><span className="me-2">Trang Chủ <i className="bi bi-chevron-right ms-2 fs-6"></i></span></a>
                </li>
                
                <li className=" parent position-relative text-wrap">
                    {
                        data[0].child && data[0].child?.length > 0?(
                            <a href={"/"+data[0].url_key+".html"}>
                                <span >{data[0].name}<i className="bi bi-chevron-right ms-2  me-2 fs-6"></i></span>
                            </a>
                        ):(
                            // <span><strong>{data[0].name}</strong></span>
                            <a href={"/"+data[0].url_key+".html"}>
                            <span >{data[0].name}</span>
                            </a>
                        ) 
                    }
                    <ul className="position-absolute px-0 z-10 pt-1 bg-white d-none">
                        {
                            data.slice(1,data.length).map((item,index)=>{
                                return<li key={index} className="ps-2 mx-1 text-truncate"><a href={"/"+item.url_key+".html"}><span >{item.name}</span></a>
                                </li>
                            })
                        
                        }
                    </ul>
                </li>
                {
                    data[0].child?.length > 0 ? (
                        <li className=" parent position-relative text-wrap">
                            {
                                 data[0].child[0]?.child &&  data[0].child[0]?.child.length > 0 ?(
                                    <a href={"/"+ data[0].child[0]?.url_key+".html"}>
                                        <span >{ data[0].child[0]?.name}<i className="bi bi-chevron-right ms-2  me-2 fs-6"></i></span>
                                    </a>
                                 ):(
                                    // <span ><strong>{ data[0].child[0]?.name}</strong></span>
                                    <a href={"/"+ data[0].child[0]?.url_key+".html"}>
                                        <span >{ data[0].child[0]?.name}</span>
                                    </a>
                                 )
                            }
                            
                            <ul className="position-absolute px-0 z-10 pt-1 bg-white d-none">
                                {
                                    data[0].child?.slice(1,data[0].child.length).map((item1,index)=>{
                                        return<li key={index} className="ps-2 mx-1 text-truncate"><a href={"/"+item1.url_key+".html"}><span >{item1.name}</span></a>
                                        </li>
                                    })
                                }
                            </ul>
                        </li>
                    ):(null)
                }
                {
                    data[0].child[0]?.child.length > 0 ? (
                        <li className=" parent position-relative text-wrap">
                            <a href={"/"+ data[0].child[0]?.child[0]?.url_key+".html"}>
                                        <span >{ data[0]?.child[0].child[0]?.name}</span>
                                    </a>
                            {/* <span >
                                <strong>{ data[0].child[0]?.child[0]?.name}</strong>
                            </span> */}
                            <ul className="position-absolute px-0 z-10 pt-1 bg-white d-none">
                                {
                                    data[0].child[0]?.child?.slice(1,data[0].child[0]?.child.length).map((item2,index)=>{
                                        return<li key={index} className="ps-2 mx-1 text-truncate"><a href={"/"+item2.url_key+".html"}><span >{item2.name}</span></a>
                                        </li>
                                    })
                                
                                }
                            </ul>
                        </li>
                    ):(null)
                }

            </ul>
        </div>
    )}else{return null;}
}
export default Breadsrumb1;